import { __rest, __assign } from 'tslib';
import React from 'react';
import '@popperjs/core';
import '../Icon/ImgIcon.esm.js';
import '../Icon/FaIcon.esm.js';
import '../Icon/SemanticIcons.esm.js';
import '../Tooltip/Tooltip.esm.js';
import { CardFooter } from '../Card/CardFooter.esm.js';

function ModalFooter(_a) {
    var _b = _a.appearance, appearance = _b === void 0 ? "primary" : _b, addClassName = _a.addClassName, passThrough = __rest(_a, ["appearance", "addClassName"]);
    return (React.createElement(CardFooter, __assign({ appearance: appearance, addClassName: "".concat(addClassName || "", " tw-py-3") }, passThrough)));
}

export { ModalFooter };
//# sourceMappingURL=ModalFooter.esm.js.map
